const ProfileDownloadCenterActions = {
    UPDATE_MODE_TYPE: "UPDATE_MODE_TYPE",
    UPDATE_SUB_MODE_TYPE: "UPDATE_SUB_MODE_TYPE",
    UPDATE_CURRENT_PREVIEW_ID: "UPDATE_CURRENT_PREVIEW_ID",
    UPDATE_CURRENT_PAGE: "UPDATE_CURRENT_PAGE",
    ZOOM_IN: "ZOOM_IN",
    ZOOM_OUT: "ZOOM_OUT",
    INCREASE_HEIGHT: "INCREASE_HEIGHT",
    DECREASE_HEIGHT: "DECREASE_HEIGHT",
    CHANGE_TEXT: "CHANGE_TEXT",
    UPDATE_TITLE_SIZE: "UPDATE_TITLE_SIZE",
    UPDATE_ELEMENT_DETAIL: "UPDATE_ELEMENT_DETAIL",
    SEARCHIFY_SUBMIT: "SEARCHIFY_SUBMIT",
    SEARCHIFY_SUBMIT_BATCH_SELECTOR: "SEARCHIFY_SUBMIT_BATCH_SELECTOR",
    REPLACE_BATCH_SEARCHIFY_FILTERS: "REPLACE_BATCH_SEARCHIFY_FILTERS",
    UPDATE_BATCH_SELECT_STATE_NAME: "UPDATE_BATCH_SELECT_STATE_NAME",
    UPDATE_BATCH_SELECT_STATE_FILTERS: "UPDATE_BATCH_SELECT_STATE_FILTERS",
    ADD_PAGE: "ADD_PAGE",
    REMOVE_PAGE: "REMOVE_PAGE",
    ADD_ELEMENT: "ADD_ELEMENT",
    REMOVE_ELEMENT: "REMOVE_ELEMENT",
    REPOSITION_ELEMENT: "REPOSITION_ELEMENT",
    LOAD_PDF_FROM_TEMPLATE: "LOAD_PDF_FROM_TEMPLATE",
    CLEAR_BATCH_SEARCHIFY_FILTERS: 'CLEAR_BATCH_SEARCHIFY_FILTERS',

    // searchify operations
    SEARCHIFY_SUBMIT_ELEMENT_FILTER: "SEARCHIFY_SUBMIT_ELEMENT_FILTER",
    PDF_BATCH_SELECTOR_SUBMIT_SEARCHIFY: 'PDF_BATCH_SELECTOR_SUBMIT_SEARCHIFY',
    PDF_STATISTICS_SUBMIT: 'PDF_STATISTICS_SUBMIT',
    PDF_SINGLE_OBJECT: 'PDF_SINGLE_OBJECT',

    UPDATE_SELECTED_ORGANIZATION_DESIGN_ID: "UPDATE_SELECTED_ORGANIZATION_DESIGN_ID",

    // My Files page
    SET_VIEW_CHOICE: "SET_VIEW_CHOICE"
}

export default ProfileDownloadCenterActions
